import axios from "axios";

export const baseURL = `${process.env.REACT_APP_APII}`;
export const http2 = `${process.env.REACT_APP_APII}/`;
export const adminId = localStorage.getItem("admin_id");

const http = axios.create({
  baseURL: baseURL,
  timeout: 100000,
});

// ✅ Only interceptor will handle token — no default headers
http.interceptors.request.use(
  async (config) => {
    const token = localStorage.getItem("token");
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => Promise.reject(error)
);

export default http;
